import React from 'react';
import Logo from '../shared/brand/Logo';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../store';
import Button from '../shared/TailwindComponents/Button';
import { Well } from '../shared/brand/Field';
import { FormActions } from '../shared/FormComponents';
import OnboardingStepCard from './OnboardingStepCard';
import {
PiBuildingOfficeLight,
  PiFadersLight,
PiUserCircleCheckLight,
} from 'react-icons/pi';

const WelcomeStep: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const onboardingUser = useSelector((state: RootState) => state.onboarding.user);

  const handleStartOnboarding = () => {
    // Skip organization step for invited users who already have an org assigned
    const nextStep = onboardingUser?.organization_id ? 'user' : 'organization';
    dispatch({
      type: 'ONBOARDING_SET_STEP',
      payload: nextStep,
    });
  };

  // The three things the flow will ask for, in the order the step rail runs
  // them - same labels, same glyphs, so the welcome card previews the rail.
  const steps = [
    {
      icon: <PiBuildingOfficeLight className="w-5 h-5" />,
      title: t('Set up your organization'),
      detail: t('Confirm or join an organization'),
    },
    {
      icon: <PiUserCircleCheckLight className="w-5 h-5" />,
      title: t('Complete your profile'),
      detail: t('Add your name and confirm role'),
    },
    {
      icon: <PiFadersLight className="w-5 h-5" />,
      title: t('Set your preferences'),
      detail: t('Configure language and settings'),
    },
  ];

  return (
    <OnboardingStepCard
      align="center"
      media={<Logo variant="mark" className="w-12 h-12" />}
      title={t('Welcome to PONS')}
      description={t("Let's set up your account in just a few steps. This will take about 5 minutes.")}
      footer={
        <FormActions>
          <Button variant="primary" size="small" onClick={handleStartOnboarding}>
            {t("Let's get started")}
          </Button>
        </FormActions>
      }
    >
      <div className="space-y-2">
        {steps.map((step) => (
          <Well key={step.title} className="flex items-start gap-3">
            <span className="mt-0.5 flex-shrink-0 text-fg-muted">{step.icon}</span>
            <div className="min-w-0">
              <p className="text-sm font-medium text-fg-strong">{step.title}</p>
              <p className="text-xs text-fg-muted">{step.detail}</p>
            </div>
          </Well>
        ))}
      </div>
    </OnboardingStepCard>
  );
};

export default WelcomeStep;
